import React from 'react';
import { cn } from '@/lib/utils';

export interface MaskImageProps {
  src: string;
  color: string;
  className?: string;
  ariaLabel?: string;
  ariaHidden?: boolean;
}

export const MaskImage: React.FC<MaskImageProps> = ({
  src,
  color,
  className,
  ariaLabel,
  ariaHidden = false,
}) => {
  const maskUrl = src && String(src).trim() ? `url(${src})` : undefined;
  const style: React.CSSProperties = {
    backgroundColor: color,
    ...(maskUrl && {
      WebkitMaskImage: maskUrl,
      maskImage: maskUrl,
      WebkitMaskSize: 'contain',
      maskSize: 'contain',
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
    }),
  };

  return (
    <div
      className={cn(className)}
      style={style}
      role="img"
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    />
  );
};
